<template>
  <div v-if="match">
    <v-card max-width="275" class="pt-2 mx-auto">
      <div>
        <v-lazy>
          <v-img
            :src="
              formatBrowseUrl(match.acquisition_id, cell_feature.properties.id)
            "
            max-height="250"
            max-width="250"
            contain
            v-bind:class="{ selected: isSelected }"
            style="cursor: pointer"
            @click="
              selectImage(cell_feature.properties.id, match.acquisition_id)
            "
          >
            <v-expand-transition>
              <div
                v-if="showMetadata"
                class="
                  d-flex
                  transition-fast-in-fast-out
                  grey
                  darken-2
                  v-card--reveal
                  white--text
                "
                style="height: 100%"
              >
                <v-responsive class="overflow-y-auto">
                  <p class="pa-2 text-wrap text-caption">
                    <span class="text--secondary">Acquisition ID:</span>
                    {{ match.acquisition_id }} <br />
                    <span class="text--secondary">Date Collected:</span>
                    {{ match.date }} <br />
                    <span class="text--secondary">Cloud Cover:</span>
                    {{ match["tile:cloud_percentage"] }}% <br />
                    <span class="text--secondary">Data Coverage:</span>
                    {{ match["tile:data_percentage"] }}% <br />
                    <span class="text--secondary">Off Nadir:</span>
                    {{ match["view:off_nadir"].toFixed(2) }}&#176;<br />
                    <span class="text--secondary">Sun Elevation:</span>
                    {{ match["view:sun_elevation"].toFixed(2) }}&#176;
                    <br />
                    <span class="text--secondary">Sensor:</span>
                    {{ match["platform"] }} <br />
                    <span v-if="is_internal"
                      ><span class="text--secondary">P3DR Support:</span>
                      {{ match.p3dr_support }}<br
                    /></span>
                  </p>
                </v-responsive>
              </div>
            </v-expand-transition>
          </v-img>
        </v-lazy>
      </div>
      <div>
        <v-card-actions class="py-0 px-4">
          <v-checkbox
            id="tile-checkbox"
            v-model="
              childModel[
                `${cell_feature.properties.id}_${match.acquisition_id}`
              ]
            "
            :label="
              childLabel(
                childModel,
                `${cell_feature.properties.id}_${match.acquisition_id}`
              )
            "
            @change="
              childAction(
                childModel,
                cell_feature.properties.id,
                match.acquisition_id
              )
            "
            hide-details
            class="mt-0"
          ></v-checkbox>
          <v-spacer />
          <div class="pt-2">
            <v-btn
              icon
              @click="clicked()"
              @mouseover="mouseover()"
              @mouseleave="mouseleave()"
            >
              <v-icon medium :color="infoColor">
                mdi-information-outline
              </v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { mapGetters } from "vuex";
const cartStore = createNamespacedHelpers("shoppingCart");

export default {
  props: ["match", "cell_feature"],
  components: {},
  computed: {
    ...mapGetters(["account_details"]),
    is_internal() {
      if (this.account_details) {
        return this.account_details.internal;
      }
      return false;
    },
    infoColor() {
      if (this.showMetadata) {
        return "secondary";
      } else {
        return "primary";
      }
    },
    isSelected() {
      if (
        this.childModel[
          `${this.cell_feature.properties.id}_${this.match.acquisition_id}`
        ]
      ) {
        return true;
      } else {
        return false;
      }
    },
    store() {
      return this.$store.state.shoppingCart.cart;
    },
  },
  watch: {
    store(newStore, oldStore) {
      this.sync();
    },
  },
  setup() {
    const { addToCart } = cartStore.useMutations(["addToCart"]);
    const { removeFromCart } = cartStore.useMutations(["removeFromCart"]);
    return { addToCart, removeFromCart };
  },
  data() {
    return {
      childModel: {},
      hover: false,
      click: false,
      showMetadata: false,
    };
  },
  mounted() {
    this.sync();
  },
  methods: {
    sync() {
      // sync order cart selection with checkbox selections
      this.childModel = {};
      this.$store.state.shoppingCart.cart.forEach((tile) => {
        this.childModel[tile.id] = true;
      });
    },
    clicked() {
      if (this.showMetadata && !this.click) {
        this.showMetadata = true;
        this.click = true;
      } else if (this.showMetadata) {
        this.showMetadata = false;
        this.click = false;
      } else {
        this.showMetadata = true;
        this.click = true;
      }
    },
    mouseover() {
      if (this.click) {
        this.hover = false;
      }
      if (!this.showMetadata && !this.click) {
        this.showMetadata = true;
        this.hover = true;
      }
    },
    mouseleave() {
      if (this.showMetadata && this.hover) {
        this.showMetadata = false;
        this.hover = false;
      }
    },
    childLabel(model, id) {
      if (model[id]) {
        return "remove from cart";
      } else {
        return "add to cart";
      }
    },
    childAction(childModel, cell_id, acq_id) {
      let id = `${cell_id}_${acq_id}`;
      // sync order cart selection with checkbox selections
      if (childModel[id]) {
        this.addToCart({
          cell: cell_id,
          id: id,
          name: acq_id,
        });
      } else {
        this.removeFromCart({
          cell: cell_id,
          id: id,
          name: acq_id,
        });
      }
    },
    selectImage(cell_id, acq_id) {
      let id = `${cell_id}_${acq_id}`;
      if (this.childModel[id]) {
        delete this.childModel[id];
      } else {
        this.childModel[id] = true;
      }
      this.childAction(this.childModel, cell_id, acq_id);
    },
    formatBrowseUrl(acq_id, cell_id) {
      return (
        "https://ard.maxar.com/api/v1/browse/preview/" + acq_id + "/" + cell_id
      );
    },
  },
};
</script>
<style scoped>
.selected {
  border: 2px solid #fcaf17;
}
</style>
